export const STRINGS = {
  app: {
    name: "OHTIS",
  },
  shell: {
    tenant: "Tenant",
    admin: "Admin",
    patient: "Patient",
    unknownTenant: "Organizzazione non trovata",
    unknownTenantDescription:
      "Il subdomain inserito non corrisponde a nessuna organizzazione registrata.",
  },
  nav: {
    dashboard: "Dashboard",
    patients: "Pazienti",
    patientDetail: "Dettaglio Paziente",
    patientCreate: "Nuovo Paziente",
    sessions: "Sessioni",
    sessionDetail: "Dettaglio Sessione",
    bundles: "Bundle",
    bundleActivate: "Attiva Bundle",
    bundleDetail: "Dettaglio Bundle",
    users: "Utenti",
    branding: "Branding",
    auditLog: "Audit Log",
    devices: "Dispositivi",
    s3RawData: "Dati raw (S3)",
    tenants: "Tenant",
    tenantCreate: "Nuovo Tenant",
    tenantDetail: "Dettaglio Tenant",
    myProfile: "La mia scheda",
    mySessions: "Le mie sessioni",
    exportPdf: "Esporta PDF",
    streamVisualizer: "Stream Visualizer",
  },
  user: {
    account: "Account",
    logout: "Esci",
  },
  auth: {
    loginTitle: "Accedi alla piattaforma",
    loginSubtitle: "Inserisci le tue credenziali per continuare",
    emailLabel: "Email",
    emailPlaceholder: "nome@esempio.it",
    passwordLabel: "Password",
    passwordPlaceholder: "Inserisci la password",
    loginButton: "Accedi",
    loggingIn: "Accesso in corso...",
    forgotPasswordLink: "Password dimenticata?",
    forgotPasswordTitle: "Recupera password",
    forgotPasswordDescription:
      "Inserisci il tuo indirizzo email e riceverai un codice per reimpostare la password.",
    sendCodeButton: "Invia codice",
    sendingCode: "Invio in corso...",
    confirmCodeTitle: "Conferma codice",
    confirmCodeDescription:
      "Inserisci il codice ricevuto via email e la nuova password.",
    codeLabel: "Codice di conferma",
    codePlaceholder: "123456",
    newPasswordLabel: "Nuova password",
    newPasswordPlaceholder: "Inserisci la nuova password",
    confirmPasswordLabel: "Conferma password",
    confirmPasswordPlaceholder: "Ripeti la nuova password",
    resetPasswordButton: "Reimposta password",
    resettingPassword: "Reimpostazione in corso...",
    passwordResetSuccess:
      "Password reimpostata con successo. Effettua il login.",
    setPasswordTitle: "Imposta la tua password",
    setPasswordDescription:
      "Il tuo account richiede l'impostazione di una nuova password per il primo accesso.",
    setPasswordButton: "Imposta password",
    settingPassword: "Impostazione in corso...",
    backToLogin: "Torna al login",
    passwordMismatch: "Le password non corrispondono",
    genericError: "Si è verificato un errore. Riprova.",
    invalidCredentials: "Credenziali non valide",
    mfaChallengeTitle: "Verifica in due passaggi",
    mfaChallengeDescription:
      "Inserisci il codice a 6 cifre generato dalla tua app di autenticazione.",
    mfaCodeLabel: "Codice TOTP",
    mfaCodePlaceholder: "000000",
    mfaVerifyButton: "Verifica",
    mfaVerifying: "Verifica in corso...",
    mfaSetupTitle: "Configura autenticazione a due fattori",
    mfaSetupDescription:
      "Scansiona il codice QR con la tua app di autenticazione (Google Authenticator, Authy, ecc.) e inserisci il codice di conferma.",
    mfaSetupSecretLabel: "Codice segreto",
    mfaSetupSecretDescription:
      "Se non riesci a scansionare il QR, inserisci questo codice manualmente nella tua app.",
    mfaSetupConfirmLabel: "Codice di conferma",
    mfaSetupConfirmPlaceholder: "000000",
    mfaSetupConfirmButton: "Conferma configurazione",
    mfaSetupConfirming: "Conferma in corso...",
    mfaCopySecret: "Copia",
    mfaSecretCopied: "Copiato!",
  },
  admin: {
    dashboardTitle: "Dashboard SuperAdmin",
    dashboardDescription:
      "Panoramica della piattaforma OHTIS. Gestione tenant, bundle e monitoraggio globale.",
    tenantsTitle: "Gestione Tenant",
    tenantsDescription:
      "Crea, configura e gestisci i tenant della piattaforma.",
    tenantDetailTitle: "Dettaglio Tenant",
    bundlesTitle: "Gestione Bundle",
    bundlesDescription: "Pre-registra, assegna e monitora i bundle IoT.",
    auditLogTitle: "Audit Log",
    auditLogDescription: "Registro delle operazioni sulla piattaforma.",
    comingSoon: "In fase di sviluppo",
    comingSoonDescription:
      "Questa sezione sarà disponibile nelle prossime release.",
    createTenant: "Nuovo Tenant",
    tenantName: "Nome",
    tenantSlug: "Slug (subdomain)",
    tenantSlugDescription: "Sarà usato come {slug}.ohtis.it",
    tenantType: "Tipo",
    tenantTypeHcp: "HCP",
    tenantTypeClinical: "Clinico",
    tenantAdminEmail: "Email primo admin",
    tenantMaxPatients: "Quota massima pazienti",
    tenantStatus: "Stato",
    tenantStatusActive: "Attivo",
    tenantStatusSuspended: "Sospeso",
    tenantCreatedAt: "Creato il",
    tenantPatients: "Pazienti",
    tenantUsers: "Utenti",
    tenantActiveSessions: "Sessioni attive",
    tenantBundles: "Bundle",
    tenantConfig: "Configurazione",
    tenantBranding: "Branding",
    creating: "Creazione in corso...",
    createButton: "Crea Tenant",
    createTenantSuccess: "Tenant creato con successo.",
    cancel: "Annulla",
    close: "Chiudi",
    noTenants: "Nessun tenant trovato",
    noTenantsDescription: "Crea il primo tenant per iniziare.",
    filterAll: "Tutti",
    filterByType: "Filtra per tipo",
    filterByStatus: "Filtra per stato",
    bundleId: "Bundle ID",
    bundleStatus: "Stato",
    bundleStatusPreRegistered: "Pre-registrato",
    bundleStatusAssigned: "Assegnato",
    bundleStatusActive: "Attivo",
    bundleStatusDecommissioned: "Dismesso",
    bundleTenant: "Tenant",
    bundlePatient: "Paziente",
    bundleLastConnected: "Ultima connessione",
    bundleActivatedAt: "Attivato il",
    bundleCreatedAt: "Creato il",
    bundleNotAssigned: "Non assegnato",
    noBundles: "Nessun bundle trovato",
    noBundlesDescription: "I bundle appariranno qui dopo la pre-registrazione.",
    loadMore: "Carica altri",
    loading: "Caricamento...",
    errorLoading: "Errore durante il caricamento",
    retry: "Riprova",
    tenantIdLabel: "Tenant ID",
    logoLabel: "Logo",
    primaryColorLabel: "Colore primario",
    secondaryColorLabel: "Colore secondario",
    domainSuffix: ".ohtis.it",
    placeholderTenantName: "Vivisol Italia",
    placeholderSlug: "vivisol-italia",
    placeholderAdminEmail: "admin@vivisol.it",
    s3RawDataTitle: "Esplora dati raw nel datalake",
    s3RawDataDescription:
      "Navigazione in sola lettura sotto raw/v1/ (bucket datalake). Richiede permesso server admin:s3_browser e JWT SuperAdmin.",
    s3RawDataFolders: "Cartelle",
    s3RawDataObjects: "Oggetti",
    s3RawDataNoFolders: "Nessuna sottocartella in questo prefisso.",
    s3RawDataNoObjects: "Nessun file in questo prefisso.",
    s3RawDataColName: "Nome",
    s3RawDataColSize: "Dimensione",
    s3RawDataColModified: "Modificato",
    s3RawDataColActions: "",
    s3RawDataDownload: "Scarica",
    s3RawDataLoadMore: "Carica altri",
    s3RawDataLoadingMore: "Caricamento…",
    s3RawDataRetry: "Riprova",
    s3RawDataUnknownError: "Errore imprevisto durante il caricamento.",
    s3RawDataConfigError: "Configurazione mancante",
    s3RawDataLoadError: "Errore di caricamento",
    s3RawDataTotalObjects: "oggetti",
    s3RawDataDownloadError:
      "Errore durante la generazione del link di download.",
    bundleDetailTitle: "Dettaglio Bundle",
    bundleDetailDescription: "Informazioni, componenti e storico sostituzioni.",
    bundleComponents: "Componenti",
    bundleNoComponents: "Nessun componente registrato per questo bundle.",
    bundleComponentWearable: "Wearable OHTIS",
    bundleComponentPulseOximeter: "Pulsossimetro",
    bundleComponentGateway: "Gateway",
    bundleComponentSerial: "Serial number",
    bundleComponentFirmware: "Firmware",
    bundleComponentStatus: "Stato",
    bundleComponentStatusActive: "Attivo",
    bundleComponentStatusReplaced: "Sostituito",
    bundleComponentReplacedAt: "Sostituito il",
    bundleGatewayNotPaired:
      "Gateway non ancora associato — verrà collegato tramite l'app mobile.",
    bundleGatewayOnline: "Online",
    bundleGatewayOffline: "Offline",
    bundleGatewayLastSeen: "Ultima connessione",
    bundleGatewayBattery: "Batteria",
    bundleGatewayStorage: "Storage usato",
    bundleReplacementHistory: "Storico sostituzioni",
    bundleReplacementHistoryEmpty: "Nessuna sostituzione registrata.",
    bundleReplacementComponent: "Componente",
    bundleReplacementOldSerial: "Vecchio serial",
    bundleReplacementNewSerial: "Nuovo serial",
    bundleReplacementDate: "Data",
    bundleReplacementBy: "Operatore",
    bundleReplaceComponent: "Sostituisci componente",
    bundleReplaceComponentTitle: "Sostituisci componente",
    bundleReplaceComponentDescription:
      "Inserisci i dati del nuovo componente. Il bundleId resterà invariato.",
    bundleReplaceComponentType: "Tipo componente",
    bundleReplaceNewSerial: "Serial number nuovo",
    bundleReplaceNewSerialPlaceholder: "SN-XXXXX",
    bundleReplaceNewFirmware: "Versione firmware",
    bundleReplaceNewFirmwarePlaceholder: "1.0.0",
    bundleReplaceSubmit: "Conferma sostituzione",
    bundleReplacing: "Sostituzione in corso...",
    bundleReplaceSuccess: "Componente sostituito con successo.",
    bundleReplaceErrorSerial: "Serial number già in uso in un altro bundle.",
    bundleRemoveComponent: "Rimuovi componente",
    bundleRemoveComponentTitle: "Rimuovi componente dal bundle",
    bundleRemoveComponentDescription:
      "Il componente verrà scollegato dal bundle e tornerà disponibile nel registro dispositivi. Il bundle resterà attivo, ma non sarà completo finché non verrà associato un nuovo componente. Questa azione non elimina il dispositivo.",
    bundleRemoveComponentConfirm: "Conferma rimozione",
    bundleRemoving: "Rimozione in corso...",
    bundleRemoveSuccess: "Componente rimosso con successo.",
    bundleComponentMissing: "Componente non associato",
    bundleComponentMissingHint:
      "Aggiungi un componente sostituendo lo slot vuoto.",
    bundleAddComponent: "Aggiungi componente",
    bundleComponentSection: "Componenti del bundle",
    bundleComponentSectionDescription:
      "Stato di ogni dispositivo associato al bundle. Sostituisci o rimuovi singolarmente.",
    bundleInfoDescription:
      "Identificativo, assegnazione e tempistiche del bundle.",
    bundleInfo: "Informazioni",
    bundleViewDetail: "Dettaglio",
    backToBundles: "Torna ai bundle",
    createBundle: "Pre-registra bundle",
    createBundleTitle: "Pre-registra bundle",
    createBundleDescription:
      "Inserisci il codice QR e i serial number dei 3 componenti del bundle.",
    createBundleQrCode: "Codice QR (= Bundle ID)",
    createBundleQrCodePlaceholder: "bnd_kit_001",
    createBundleWearable: "Wearable OHTIS",
    createBundlePulseOximeter: "Pulsossimetro (O2Ring)",
    createBundleGateway: "Gateway",
    createBundleSerial: "Serial number",
    createBundleSerialPlaceholder: "SN-XXXXX",
    createBundleFirmware: "Firmware",
    createBundleFirmwarePlaceholder: "1.0.0",
    createBundleSelectWearable: "Seleziona wearable",
    createBundleSelectPulseOximeter: "Seleziona pulsossimetro",
    createBundleSelectPlaceholder: "Seleziona un dispositivo...",
    createBundleNoDevicesAvailable:
      "Nessun dispositivo disponibile per questo tipo.",
    createBundleSubmit: "Pre-registra",
    createBundleCreating: "Registrazione in corso...",
    createBundleSuccess: "Bundle pre-registrato con successo.",
    createBundleErrorExists: "Un bundle con questo codice QR esiste già.",
    assignBundle: "Assegna a tenant",
    assignBundleTitle: "Assegna bundle a tenant HCP",
    assignBundleDescription:
      "Seleziona il tenant HCP a cui assegnare il bundle. Solo bundle in stato pre-registrato possono essere assegnati.",
    assignBundleTenant: "Tenant HCP",
    assignBundleTenantPlaceholder: "Seleziona un tenant...",
    assignBundleSubmit: "Assegna",
    assignBundleAssigning: "Assegnazione in corso...",
    assignBundleSuccess: "Bundle assegnato con successo.",
    assignBundleErrorNotAvailable:
      "Il bundle non è in stato pre-registrato e non può essere assegnato.",
    assignBundleNoTenants: "Nessun tenant HCP disponibile.",
    releaseBundleTitle: "Rilascia bundle",
    releaseBundleDescription:
      "Il bundle verrà dissociato dal paziente e tornerà disponibile per il tenant HCP. Il paziente perderà l'accesso al bundle e non potrà avviare nuove sessioni fino a quando non gli verrà assegnato un nuovo bundle.",
    releaseBundleConfirm: "Rilascia",
    releaseBundleReleasing: "Rilascio in corso...",
    releaseBundleSuccess: "Bundle rilasciato con successo.",
    unassignBundleTitle: "Rimuovi assegnazione tenant",
    unassignBundleDescription:
      "Il bundle verrà rimosso dal tenant HCP e tornerà in stato pre-registrato. Il tenant non avrà più visibilità su questo bundle e non potrà assegnarlo ai propri pazienti.",
    unassignBundleConfirm: "Rimuovi assegnazione",
    unassignBundleUnassigning: "Rimozione in corso...",
    unassignBundleSuccess: "Assegnazione rimossa con successo.",
    decommissionBundleTitle: "Dismetti bundle",
    decommissionBundleDescription:
      "Il bundle verrà dismesso definitivamente. I dispositivi contenuti (wearable, pulsossimetro, gateway) verranno rilasciati e torneranno disponibili per essere inseriti in un nuovo bundle. Se il bundle è attivo, il paziente perderà l'accesso. Questa azione è irreversibile.",
    decommissionBundleConfirm: "Dismetti",
    decommissionBundleDecommissioning: "Dismissione in corso...",
    decommissionBundleSuccess: "Bundle dismesso con successo.",
    bundleActions: "Azioni",
    bundleActionRelease: "Rilascia da paziente",
    bundleActionUnassign: "Rimuovi da tenant",
    bundleActionDecommission: "Dismetti",
    bundleFilterByTenant: "Tutti i tenant",
    bundleFilterTenantLabel: "Tenant",
    devicesTitle: "Anagrafica Dispositivi",
    devicesDescription:
      "Registro dei componenti hardware. Registra, monitora e gestisci wearable, pulsossimetri e gateway.",
    deviceSerial: "Serial number",
    deviceType: "Tipo",
    deviceTypeWearable: "Wearable",
    deviceTypePulseOximeter: "Pulsossimetro",
    deviceTypeGateway: "Gateway",
    deviceStatus: "Stato",
    deviceStatusAvailable: "Disponibile",
    deviceStatusInBundle: "In bundle",
    deviceStatusDecommissioned: "Dismesso",
    deviceStatusFactoryReset: "Factory reset",
    deviceMac: "MAC Address",
    deviceFirmware: "Firmware",
    deviceBundle: "Bundle",
    devicePurchaseDate: "Data acquisto",
    deviceWarrantyExpiry: "Scadenza garanzia",
    deviceCalibrationDate: "Data calibrazione",
    deviceNotes: "Note",
    deviceCreatedAt: "Registrato il",
    deviceCreatedBy: "Registrato da",
    deviceUpdatedAt: "Aggiornato il",
    deviceBundleHistory: "Storico bundle",
    deviceBundleHistoryEmpty: "Nessun assegnamento registrato.",
    deviceBundleHistoryAction: "Azione",
    deviceBundleHistoryBundle: "Bundle",
    deviceBundleHistoryDate: "Data",
    deviceBundleHistoryActionAssigned: "Assegnato",
    deviceBundleHistoryActionRemoved: "Rimosso (sostituzione)",
    deviceBundleHistoryActionReplacement: "Assegnato (sostituzione)",
    noDevices: "Nessun dispositivo trovato",
    noDevicesDescription:
      "I dispositivi appariranno qui dopo la registrazione.",
    registerDevice: "Registra dispositivo",
    registerDeviceTitle: "Registra nuovo dispositivo",
    registerDeviceDescription:
      "Inserisci i dati del componente hardware. Il serial number deve essere unico.",
    registerDeviceSerialPlaceholder: "WRB-2024-001",
    registerDeviceMacPlaceholder: "AA:BB:CC:DD:EE:FF",
    registerDeviceFirmwarePlaceholder: "1.0.0",
    registerDeviceNotesPlaceholder: "Lotto produzione, note interne...",
    registerDeviceSubmit: "Registra",
    registerDeviceCreating: "Registrazione in corso...",
    registerDeviceSuccess: "Dispositivo registrato con successo.",
    registerDeviceErrorExists:
      "Un dispositivo con questo serial number esiste già.",
    deviceDetailTitle: "Dettaglio Dispositivo",
    deviceDetailDescription:
      "Metadati, stato e storico bundle del dispositivo.",
    deviceEdit: "Modifica",
    deviceEditTitle: "Modifica dispositivo",
    deviceEditSubmit: "Salva modifiche",
    deviceEditSaving: "Salvataggio in corso...",
    deviceEditSuccess: "Dispositivo aggiornato con successo.",
    deviceDecommission: "Dismetti",
    deviceDecommissionTitle: "Dismetti dispositivo",
    deviceDecommissionDescription:
      "Questa azione è irreversibile. Il dispositivo non potrà più essere assegnato a nessun bundle.",
    deviceDecommissionConfirm: "Conferma dismissione",
    deviceDecommissioning: "Dismissione in corso...",
    deviceDecommissionSuccess: "Dispositivo dismesso con successo.",
    deviceDecommissionErrorInBundle:
      "Il dispositivo è ancora assegnato a un bundle. Rimuovilo prima di dismettere.",
    backToDevices: "Torna ai dispositivi",
    deviceInfo: "Informazioni",
    deviceShowRetired: "Mostra dispositivi ritirati",
    deviceShowRetiredHint:
      "Include dispositivi dismessi e con factory reset nella lista.",
    deviceActions: "Azioni",
    gatewayFactoryReset: "Factory reset",
    gatewayFactoryResetDisabledInBundle:
      "Gateway attualmente in un bundle. Rimuovilo dal bundle prima di eseguire il factory reset.",
    gatewayFactoryResetDisabledAlreadyReset:
      "Gateway già sottoposto a factory reset.",
    gatewayFactoryResetTitle: "Factory reset gateway {serialNumber}?",
    gatewayFactoryResetDescription:
      "Questa operazione eliminerà in modo permanente l'IoT Thing, il certificato X.509 e il record CERT_LOOKUP associato a questo gateway. L'app mobile abbinata perderà la connettività e dovrà essere riprovvisionata. Il record DDB viene preservato ai fini di audit (lo stato diventerà factory_reset). Questa azione non può essere annullata.",
    gatewayFactoryResetConfirmSerialLabel:
      "Digita il serial number per confermare",
    gatewayFactoryResetConfirmSerialPlaceholder: "Serial number esatto",
    gatewayFactoryResetConfirmButton: "Factory reset",
    gatewayFactoryResetting: "Factory reset in corso...",
    gatewayFactoryResetSuccess:
      "Gateway {serialNumber} sottoposto a factory reset.",
    gatewayFactoryResetAlreadyReset:
      "Il gateway è già stato sottoposto a factory reset.",
    gatewayFactoryResetInBundle:
      "Il gateway è in un bundle e deve essere rimosso prima del factory reset.",
    gatewayFactoryResetInBundleWithId:
      "Il gateway è nel bundle {bundleId}. Rimuovilo dal bundle (replace-component) prima del factory reset.",
    gatewayFactoryResetOpenBundle: "Apri bundle",
    gatewayFactoryResetBannerTitle: "Gateway sottoposto a factory reset",
    gatewayFactoryResetBannerDescription:
      "L'identità IoT di questo gateway è stata distrutta. Per riprovvisionare lo stesso serial, utilizza il flusso di provisioning lato tecnico.",
    gatewayFactoryResetBannerAt: "Eseguito il",
    gatewayFactoryResetBannerBy: "Eseguito da",
    gatewayProvisioningHistory: "Storico provisioning",
    gatewayProvisioningHistoryEmpty:
      "Nessun provisioning precedente registrato per questo gateway.",
    gatewayProvisioningHistoryThingName: "IoT Thing",
    gatewayProvisioningHistoryCertificate: "Certificato",
    gatewayProvisioningHistoryProvisionedAt: "Provvisionato il",
    gatewayProvisioningHistoryProvisionedBy: "Da",
    gatewayProvisioningHistoryFactoryResetAt: "Factory reset il",
    gatewayProvisioningHistoryFactoryResetBy: "Da",
    gatewayProvisioningHistoryReprovisionedAt: "Riprovvisionato il",
    gatewayProvisioningHistoryReprovisionedBy: "Da",
    streamVisualizerTitle: "Stream Chunk Visualizer",
    streamVisualizerDescription:
      "Debug tool — visualizza i dati BLE decodificati come serie temporali interattive.",
    streamVisualizerTenant: "Tenant",
    streamVisualizerTenantPlaceholder: "Seleziona tenant...",
    streamVisualizerPatient: "Paziente",
    streamVisualizerPatientPlaceholder: "Seleziona paziente...",
    streamVisualizerSession: "Sessione",
    streamVisualizerSessionPlaceholder: "Seleziona sessione...",
    streamVisualizerSessionId: "Session ID",
    streamVisualizerSessionIdPlaceholder: "Inserisci UUID sessione",
    streamVisualizerLoad: "Carica",
    streamVisualizerLoading: "Caricamento stream...",
    streamVisualizerExportRaw: "Esporta raw",
    streamVisualizerExporting: "Esportazione...",
    streamVisualizerTotalSamples: "Campioni totali",
    streamVisualizerUnit: "Unità",
    streamVisualizerNoData: "Nessun dato caricato",
    streamVisualizerNoDataDescription:
      "Seleziona una sessione o inserisci un Session ID, poi premi Carica per visualizzare tutti gli stream.",
    streamVisualizerErrorLoad: "Errore durante il caricamento dello stream.",
    streamVisualizerStreamLoadError: "Impossibile caricare questo stream.",
    streamVisualizerLinkedZoomHint:
      "Zoom, pan e finestra temporale sull'asse X sono collegati tra tutti i grafici.",
    streamVisualizerErrorExport: "Errore durante l'esportazione raw.",
    streamVisualizerReload: "Ricarica",
    streamVisualizerRefreshing: "Aggiornamento…",
    streamVisualizerSessionEnded: "Sessione conclusa — no auto-refresh",
    streamVisualizerManifestTitle: "manifest_v1.json",
    streamVisualizerManifestDownload: "Apri manifest",
    streamVisualizerManifestLoading: "Caricamento manifest…",
    streamVisualizerManifestNoContent:
      "Contenuto non disponibile inline. Utilizza il pulsante per aprire il file.",
  },
  tenant: {
    patientsTitle: "Pazienti",
    patientsDescription:
      "Lista dei pazienti del tenant. Cerca, filtra e gestisci i dati anagrafici.",
    patientDetailTitle: "Scheda Paziente",
    createPatient: "Nuovo Paziente",
    createPatientDescription:
      "Registra un nuovo paziente inserendo i dati anagrafici e il tipo di percorso.",
    selectDate: "Seleziona data",
    editPatient: "Modifica Paziente",
    patientFirstName: "Nome",
    patientLastName: "Cognome",
    patientBirthDate: "Data di nascita",
    patientFiscalCode: "Codice fiscale",
    patientType: "Tipo paziente",
    patientTypeScreening: "Screening",
    patientTypeO2Therapy: "Ossigenoterapia",
    patientStatus: "Stato",
    patientStatusActive: "Attivo",
    patientStatusInactive: "Inattivo",
    patientOnline: "Online",
    patientOffline: "Offline",
    patientLastSession: "Ultima sessione",
    patientTotalSessions: "Sessioni totali",
    patientBundle: "Bundle assegnato",
    patientNoBundleAssigned: "Nessun bundle",
    patientMetricsAhi: "AHI",
    patientMetricsOdi3: "ODI3",
    patientMetricsSpO2: "SpO₂ media",
    patientNoMetrics: "—",
    patientSearchPlaceholder: "Cerca per nome o codice fiscale...",
    noPatients: "Nessun paziente trovato",
    noPatientsDescription: "I pazienti appariranno qui dopo la registrazione.",
    filterAll: "Tutti",
    filterByType: "Tipo",
    filterByStatus: "Stato",
    filterOnlineOnly: "Solo online",
    sortByName: "Nome",
    sortByLastSession: "Ultima sessione",
    sortByCreatedAt: "Data registrazione",
    o2PrescriptionTitle: "Prescrizione O₂",
    o2PrescriptionFlow: "Flusso prescritto (L/min)",
    o2PrescriptionTherapyType: "Tipo terapia",
    o2TherapyNocturnal: "Notturna",
    o2TherapyContinuous: "Continua",
    o2TherapyOnDemand: "Al bisogno",
    o2PrescriptionPrescribedBy: "Prescritto da",
    o2PrescriptionValidUntil: "Valido fino al",
    clinicalAssignments: "Assegnazioni cliniche",
    clinicalAssignmentAdd: "Assegna a clinica",
    clinicalAssignmentAddDescription:
      "Collega il paziente a una struttura clinica per la condivisione dei dati.",
    clinicalAssignmentRemove: "Rimuovi",
    clinicalAssignmentTenant: "Clinica",
    clinicalAssignmentDate: "Data assegnazione",
    clinicalAssignmentBy: "Assegnato da",
    clinicalAssignmentEmpty: "Nessuna assegnazione clinica attiva.",
    clinicalAssignmentConfirmRemove:
      "Sei sicuro di voler rimuovere questa assegnazione clinica?",
    tabSessions: "Sessioni",
    tabScreeningPeriod: "Periodo Screening",
    tabTrend: "Trend",
    tabAnnotations: "Annotazioni",
    sessionCardDate: "Data",
    sessionCardDuration: "Durata",
    sessionCardQuality: "Qualità",
    sessionCardActive: "In corso",
    sessionCardViewLive: "Visualizza live",
    noSessions: "Nessuna sessione registrata",
    noSessionsDescription:
      "Le sessioni appariranno qui dopo l'acquisizione dei dati.",
    sessionDetailTitle: "Dettaglio Sessione",
    sessionStatus: "Stato",
    sessionStartedAt: "Inizio",
    sessionEndedAt: "Fine",
    sessionDuration: "Durata",
    sessionQuality: "Qualità",
    sessionBundle: "Bundle",
    sessionProvisional: "Provvisorio",
    sessionIndicesTitle: "Indici della sessione",
    sessionIndicesNotAvailable:
      "Dati non ancora disponibili. In attesa del servizio di elaborazione indici.",
    sessionIndicesPartial:
      "Dati parziali — elaborazione in corso, i valori verranno aggiornati automaticamente.",
    sessionIndicesLoadError:
      "Impossibile caricare gli indici della sessione.",
    sessionIndicesRetry: "Riprova",
    sessionIndicesProcessedAt: "Elaborato",
    sessionIndicesAlgoVersion: "Algoritmo",
    sessionIndicesSeverityNormal: "Normale",
    sessionIndicesSeverityMild: "Lieve",
    sessionIndicesSeverityModerate: "Moderato",
    sessionIndicesSeveritySevere: "Severo",
    sessionIndicesSeverityUnknown: "N/D",
    sessionIndicesNadirSuffix: " (nadir)",
    sessionIndicesT90PercentSuffix: "%",
    sessionIndicesT90Minutes: "min",
    sessionIndicesSleepEfficiency: "Efficienza sonno",
    sessionIndicesSleepHours: "h",
    sessionIndicesSleepMinutes: "min",
    sessionIndicesWaso: "WASO",
    // I/E ratio is shown as a plain decimal (e.g. ``0,39``); the
    // legacy ``1:0,39`` notation has been retired across the page.
    sessionIndicesIeRatioPrefix: "",
    sessionIndicesSecondsUnit: "s",
    sessionIndicesBpmUnit: "bpm",
    sessionIndicesSpO2Unit: "%",
    sessionIndicesAhiUnit: "ev/h",
    sessionIndicesOdiUnit: "ev/h",
    sessionIndicesRrUnit: "atti/min",
    sessionChartsTitle: "Curve della sessione",
    sessionChartsNotAvailable:
      "Visualizzazione curve non ancora disponibile. In attesa del servizio dati.",
    sessionChartsLinkedZoomHint:
      "Zoom e pan sull'asse temporale sono sincronizzati tra i quattro grafici.",
    sessionChartsLoading: "Caricamento campioni...",
    sessionChartsStreamLoadError: "Impossibile caricare questa curva.",
    sessionChartsLoadError:
      "Errore durante il caricamento delle curve della sessione.",
    sessionChartsStreamEmpty: "Nessun campione disponibile per questo stream.",
    sessionChartsResetZoom: "Reset zoom",
    sessionChartsRefreshing: "Aggiornamento in corso...",
    sessionChartsLivePolling: "Polling NRT attivo",
    sessionChartsCompleteness: "Completezza",
    sessionChartsSamplesSuffix: "campioni",
    sessionChartsUpdatedAgoPrefix: "Aggiornato ",
    sessionChartsMoreDataIncoming:
      "Dati parziali caricati. Ulteriori chunk verranno aggiunti automaticamente.",
    sessionNrtLiveBadge: "In diretta",
    sessionNrtPollingHint:
      "Aggiornamento automatico: curve ogni 15s, indici ogni 90s.",
    sectionRespiratory: "Respiratorio",
    sectionOximetry: "Ossimetria",
    sectionCardiac: "Cardiaco",
    sectionSleep: "Sonno",
    sectionPosition: "Posizione",
    indexAhi: "AHI",
    indexRr: "RR (media ± SD)",
    indexIeRatio: "Rapporto I/E",
    indexInspTime: "Tempo inspiratorio",
    indexExpTime: "Tempo espiratorio",
    indexSpO2Avg: "SpO₂ media",
    indexSpO2Min: "SpO₂ min",
    indexSpO2Nadir: "SpO₂ nadir",
    indexOdi3: "ODI3",
    indexOdi4: "ODI4",
    indexT90: "T90",
    indexHrAvg: "FC media",
    indexHrMin: "FC min",
    indexHrMax: "FC max",
    indexSleepDuration: "Durata sonno",
    indexSleepEfficiency: "Efficienza sonno",
    indexWaso: "WASO",
    positionSupine: "Supino",
    positionProne: "Prono",
    positionLeftLateral: "Laterale SX",
    positionRightLateral: "Laterale DX",
    positionUpright: "Eretto",
    positionSeated: "Seduto",
    positionOther: "Altro",
    positionSupineCenter: "Supino centrale",
    positionSupineRight: "Supino DX",
    positionSupineLeft: "Supino SX",
    positionProneCenter: "Prono centrale",
    positionProneRight: "Fianco DX",
    positionProneLeft: "Fianco SX",
    sessionAnalysisStatusReady: "Analisi pronta",
    sessionAnalysisStatusPending: "Elaborazione",
    sessionAnalysisStatusMissing: "Analisi non disponibile",
    sessionAnalysisPendingHint:
      "L'elaborazione della pipeline è in corso. Le sovrapposizioni cliniche e i grafici di analisi compariranno automaticamente al termine.",
    sessionAnalysisMissingHint:
      "I file di analisi prodotti dalla pipeline non sono disponibili per questa sessione. Visualizza solo le curve grezze.",
    sessionViewLabel: "Vista",
    sessionViewSonno: "Cardio-respiratorio notturno",
    sessionViewVeglia: "Analisi del respiro",
    sessionChartsOverlayToggle: "Overlay analisi",
    sessionAnnotateToggle: "Crea annotazione",
    sessionAnnotateToggleOn: "Annotazione attiva",
    sessionAnnotateHintOff:
      "Trascina per zoom e pan; ruota la rotella per zoomare l'intervallo temporale.",
    sessionAnnotateHintOn:
      "Trascina su una traccia per selezionare l'intervallo da annotare.",
    sessionChartsPlotsBarTitle: "Tracce",
    sessionChartsPlotsBarHint: "Trascina per riordinare. Usa l'icona per mostrare/nascondere.",
    sessionChartsPlotsBarHide: "Nascondi traccia",
    sessionChartsPlotsBarShow: "Mostra traccia",
    kpiHeroTitle: "Indici principali",
    kpiHeroAhi: "AHI",
    kpiHeroOdi: "ODI",
    kpiHeroT90: "T90",
    kpiHeroT90Sub: "min totali",
    kpiHeroRr: "RR media",
    kpiHeroIe: "I/E",
    kpiHeroSleepWake: "Sonno / Veglia",
    kpiHeroPosition: "Posizione",
    kpiHeroSleep: "Sonno",
    kpiHeroWake: "Veglia",
    kpiHeroNoData: "—",
    eventsTitle: "Eventi clinici",
    eventsApneaTitle: "Apnee e Ipopnee",
    eventsApnea: "Apnea",
    eventsHypopnea: "Ipopnea",
    eventsSnoringTitle: "Russamento",
    eventsAnomalyTitle: "Anomalie del respiro",
    eventsAnomalyDetailsTitle: "Anomalie del respiro (dettaglio)",
    eventsDisconnectionTitle: "Disconnessioni",
    eventsColTime: "Inizio",
    eventsColDuration: "Durata",
    eventsColType: "Tipo",
    eventsColMean: "Media",
    eventsEmpty: "Nessun evento rilevato.",
    eventsZoomTitle: "Centra timeline su questo evento",
    workbenchTitle: "Tracciati clinici",
    workbenchAnalysisLanes: "Tracce di analisi",
    laneApnea: "Apnee / Ipopnee",
    laneSnoring: "Russamento",
    laneAnomaly: "Anomalie respiro",
    laneDisconnection: "Disconnessioni",
    laneRr: "Frequenza respiratoria",
    laneIe: "Rapporto I:E",
    laneFlow: "Portata O₂",
    lanePosition: "Posizione corporea",
    laneMovement: "Movimento",
    laneActimetry: "Actimetria (classi)",
    annotationsTitle: "Note e annotazioni cliniche",
    pipelineFooterAlgo: "Algoritmo",
    pipelineFooterProcessed: "Elaborato",
    pipelineFooterVersion: "Pipeline",
    bundlesTitle: "Bundle",
    bundlesDescription:
      "Gestisci i bundle IoT assegnati al tenant. Visualizza stato, connettività e alert.",
    bundleActivateTitle: "Attiva Bundle",
    bundleActivateDescription:
      "Associa un bundle disponibile a un paziente in tre passaggi.",
    bundleActivateStepIdentify: "Identifica Bundle",
    bundleActivateStepPatient: "Seleziona Paziente",
    bundleActivateStepConfirm: "Conferma",
    bundleActivateCodeLabel: "Codice Bundle",
    bundleActivateCodePlaceholder: "Cerca per Bundle ID...",
    bundleActivateBundleSearch: "Bundle disponibili",
    bundleActivateNoBundles: "Nessun bundle disponibile per l'attivazione.",
    bundleActivatePatientSearch: "Cerca paziente da associare...",
    bundleActivateNoPatients: "Nessun paziente senza bundle attivo.",
    bundleActivateConfirmMessage:
      "Stai per attivare il bundle {bundleId} per il paziente {patientName}.",
    bundleActivateSuccess: "Bundle attivato con successo.",
    bundleActivateError: "Errore durante l'attivazione del bundle.",
    bundleConnectivityOnline: "Online",
    bundleConnectivityOffline: "Offline",
    bundleAlertOffline24h: "Offline da 24h+",
    bundleAlertLowBattery: "Batteria scarica",
    usersTitle: "Utenti",
    usersDescription:
      "Gestisci gli utenti del tenant. Invita nuovi operatori e gestisci gli accessi.",
    inviteUser: "Invita utente",
    inviteUserDescription:
      "Invia un invito via email per registrare un nuovo operatore.",
    inviteUserEmail: "Email",
    inviteUserEmailPlaceholder: "nome@esempio.it",
    inviteUserFirstName: "Nome",
    inviteUserLastName: "Cognome",
    inviteUserRole: "Ruolo",
    inviteUserRoleTecnico: "Tecnico",
    inviteUserRoleMedicoHcp: "Medico HCP",
    inviteUserRoleInfermiereHcp: "Infermiere HCP",
    inviteUserSubmit: "Invia invito",
    inviteUserSubmitting: "Invio in corso...",
    inviteUserSuccess: "Invito inviato con successo.",
    disableUser: "Disabilita utente",
    disableUserConfirm:
      "Sei sicuro di voler disabilitare questo utente? Non potrà più accedere alla piattaforma.",
    disableUserSuccess: "Utente disabilitato con successo.",
    userEmail: "Email",
    userName: "Nome",
    userRole: "Ruolo",
    userStatus: "Stato",
    userLastLogin: "Ultimo accesso",
    userCreatedAt: "Registrato il",
    noUsers: "Nessun utente trovato",
    noUsersDescription: "Invita il primo operatore per iniziare.",
    roleTecnico: "Tecnico",
    roleMedicoHcp: "Medico HCP",
    roleInfermiereHcp: "Infermiere HCP",
    roleAdminHcp: "Admin HCP",
    roleMedico: "Medico",
    roleInfermiere: "Infermiere",
    roleAdminClinico: "Admin Clinico",
    dashboardTitle: "Dashboard",
    dashboardDescription: "Panoramica dei pazienti e delle metriche operative.",
    dashboardMetricsTotalPatients: "Pazienti totali",
    dashboardMetricsOnlineNow: "Online ora",
    dashboardMetricsScreening: "In screening",
    dashboardMetricsO2Therapy: "In ossigenoterapia",
    dashboardNotAvailable: "In attesa del servizio di aggregazione dati.",
    auditLogTitle: "Audit Log",
    auditLogDescription:
      "Registro delle operazioni effettuate dagli utenti del tenant.",
    auditLogNotAvailable: "In attesa del servizio audit.",
    brandingTitle: "Branding",
    brandingDescription:
      "Personalizza l'aspetto della piattaforma con il logo e i colori del tenant.",
    brandingNotAvailable: "In attesa del servizio branding.",
    comingSoon: "Disponibile prossimamente",
    comingSoonDescription:
      "Questa funzionalità sarà attivata nelle prossime release.",
    save: "Salva",
    saving: "Salvataggio...",
    cancel: "Annulla",
    confirm: "Conferma",
    close: "Chiudi",
    back: "Indietro",
    next: "Avanti",
    loading: "Caricamento...",
    loadMore: "Carica altri",
    retry: "Riprova",
    errorLoading: "Errore durante il caricamento",
    noData: "Nessun dato",
    patientCreatedSuccess: "Paziente creato con successo.",
    patientUpdatedSuccess: "Paziente aggiornato con successo.",
    clinicalAssignmentCreatedSuccess:
      "Assegnazione clinica creata con successo.",
    clinicalAssignmentRemovedSuccess:
      "Assegnazione clinica rimossa con successo.",
    clinicalAssignmentTenantPlaceholder: "Seleziona una clinica...",
    clinicalAssignmentNoTenants: "Nessuna clinica disponibile.",
    clinicalAssignmentTenantIdLabel: "ID tenant clinico",
    clinicalAssignmentTenantIdManualHint:
      "L'elenco delle cliniche è disponibile solo per gli amministratori di piattaforma. Inserisci l'identificativo del tenant clinico fornito dalla struttura o dal supporto.",
    clinicalAssignmentTenantIdPlaceholder: "Incolla l'ID del tenant clinico",
    clinicalAssignmentTenantIdRequired: "Inserisci l'ID del tenant clinico.",
    clinicalAssignmentErrorClinicalTenantNotFound:
      "Struttura clinica non trovata. Controlla l'ID del tenant clinico e riprova.",
    clinicalAssignmentErrorAssignmentExists:
      "Questo paziente risulta già assegnato a questa struttura clinica.",
    clinicalAssignmentErrorRemoveNotPossible:
      "Impossibile rimuovere l'assegnazione: non trovata o non consentita per il tuo tenant.",
    bundleDetailDescription: "Informazioni e stato del bundle assegnato.",
    bundleReleasedSuccess: "Bundle rilasciato dal paziente con successo.",
    bundleConnectivity: "Connettività",
    bundlePatientLabel: "Paziente assegnato",
    bundleAlerts: "Alert",
    bundleNoAlerts: "Nessun alert attivo.",
    userDisabledSuccess: "Utente disabilitato con successo.",
    inviteSentSuccess: "Invito inviato con successo.",
  },
  api: {
    error400: "Dati non validi. Controlla i campi e riprova.",
    error401: "Sessione scaduta. Effettua nuovamente il login.",
    error403: "Non hai i permessi per eseguire questa operazione.",
    error404: "La risorsa richiesta non è stata trovata.",
    error409:
      "Conflitto: l'operazione non può essere completata. I dati potrebbero essere già presenti.",
    error422: "I dati inviati non sono validi. Verifica e riprova.",
    error429: "Troppe richieste. Attendi qualche istante e riprova.",
    error500: "Errore interno del server. Riprova più tardi.",
    error503:
      "Servizio temporaneamente non disponibile. Riprova tra qualche minuto.",
    errorGeneric: "Si è verificato un errore imprevisto. Riprova.",
  },
} as const;
